import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

export function RequireAuth(): JSX.Element {
  const { user, isLoading } = useAuthStore();
  const location = useLocation();

  if (isLoading) return <div style={{ padding: 24 }}>A carregar…</div>;
  if (!user) {
    return <Navigate to="/conta/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
